module.exports = __webpack_public_path__ + "static/media/next-gen.b9733a41.webp";